import React, { useState } from 'react';
import { getUsuarioActual } from '../apiAuth';

// Primer acceso de un usuario Básico (mig 116). Mientras no cambie la contraseña, el
// backend solo le permite PUT /mi-perfil/password (auth/cambioPassword.js); App.js muestra solo esto.
const MINIMO = 10;
const input = { width: '100%', padding: '9px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit' };
const label = { fontSize: 13, color: '#374151', display: 'block', marginBottom: 4, fontWeight: 600 };

export default function CambioPasswordObligatorio() {
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setError('');
    if (nueva.length < MINIMO) return setError(`La nueva contraseña debe tener al menos ${MINIMO} caracteres.`);
    if (nueva !== confirmar) return setError('La confirmación no coincide.');
    if (nueva === actual) return setError('La nueva contraseña no puede ser igual a la actual.');
    setEnviando(true);
    try {
      const r = await fetch('/api/mi-perfil/password', {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password_actual: actual, password_nuevo: nueva }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) return setError(d.error || 'No se pudo cambiar la contraseña');
      const u = getUsuarioActual();
      // Tras el cambio entra al Simulador (mig 122), no al último módulo.
      if (u) { delete u.debe_cambiar_password; u.ultimo_modulo = null; localStorage.setItem('usuarioActual', JSON.stringify(u)); }
      window.location.reload();
    } catch {
      setError('Error de conexión con el servidor');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '32px 16px' }}>
      <form onSubmit={enviar} style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 12, padding: 28, width: 420, maxWidth: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
        <h2 style={{ margin: '0 0 8px', color: '#1a3a6e', fontSize: 20 }}>Cambia tu contraseña</h2>
        <p style={{ fontSize: 14, color: '#4b5563', margin: '0 0 18px' }}>
          Es tu primer acceso. Para continuar, define una contraseña nueva (mínimo {MINIMO} caracteres, distinta de la actual).
        </p>
        {error && <div role="alert" style={{ padding: 10, borderRadius: 8, backgroundColor: '#fee2e2', color: '#991b1b', fontSize: 14, marginBottom: 14 }}>{error}</div>}
        <div style={{ marginBottom: 12 }}><label style={label}>Contraseña actual</label>
          <input aria-label="Contraseña actual" type="password" value={actual} onChange={e => setActual(e.target.value)} style={input} autoComplete="current-password" /></div>
        <div style={{ marginBottom: 12 }}><label style={label}>Nueva contraseña</label>
          <input aria-label="Nueva contraseña" type="password" value={nueva} onChange={e => setNueva(e.target.value)} style={input} autoComplete="new-password" /></div>
        <div style={{ marginBottom: 18 }}><label style={label}>Confirmar nueva contraseña</label>
          <input aria-label="Confirmar nueva contraseña" type="password" value={confirmar} onChange={e => setConfirmar(e.target.value)} style={input} autoComplete="new-password" /></div>
        <button type="submit" disabled={enviando} style={{ width: '100%', padding: 11, border: 'none', borderRadius: 8, backgroundColor: '#1a3a6e', color: 'white', fontWeight: 'bold', fontSize: 15, cursor: 'pointer', opacity: enviando ? 0.6 : 1 }}>
          {enviando ? 'Guardando…' : 'Guardar y continuar'}
        </button>
      </form>
    </div>
  );
}
